import * as types from 'modules/screensaver/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @typedef {import('utils/ReduxUtils').EntitySlice<import("../types/screensaver-data").Screensaver>} ScreensaverEntity */

/** @type {import('utils/ReduxUtils').EntityAdapter<import("../types/screensaver-data").Screensaver>} */
export const screensaverAdapter = createEntityAdapter({ selectId: ({ id }) => id });

/**
 * @param {ScreensaverEntity} state
 * @param {import('modules/global/generic.types').PageContent<import("../types/screensaver-data").Screensaver>} action
 * @returns {ScreensaverEntity}
 */
const updateManyFromPage = (state, { payload: { content: screensavers } }) =>
  screensaverAdapter.updateMany(state, screensavers);

export default createReducer(screensaverAdapter.getInitialState(), {
  [types.FETCH_SCREENSAVERS_SUCCESS]: updateManyFromPage,
  [types.FETCH_AVAILABLE_SCREENSAVERS_SUCCESS]: updateManyFromPage,
  [types.FETCH_SCREENSAVER_SUCCESS]: screensaverAdapter.addOne,
  [types.CREATE_SCREENSAVER_SUCCESS]: screensaverAdapter.addOne,
  [types.UPDATE_SCREENSAVER_SUCCESS]: screensaverAdapter.updateOne,
  [types.CLONE_SCREENSAVER_SUCCESS]: screensaverAdapter.addOne,
  [types.DELETE_SCREENSAVER_SUCCESS]: screensaverAdapter.removeOne,
});
